import { type ThemeConfig, theme } from 'antd';

/**
 * ÚNICA fuente de color de la app (ver src/styles/CLAUDE.md, "dónde cambiar qué").
 *
 * antd calcula el resto de tokens con el algoritmo claro/oscuro; `ThemeBridge` (theme-bridge.tsx)
 * los publica como variables `--ipb-*` en `:root`, de donde derivan Tailwind, shadcn y el chat.
 * Cambiar `colorPrimary` aquí cambia antd, Tailwind y el chat a la vez.
 */

/** Tokens de marca comunes a claro y oscuro. */
const brandTokens: ThemeConfig['token'] = {
  colorPrimary: '#fe1e00',
  colorInfo: '#fe1e00',
};

/** Tokens propios de cada modo. */
const lightTokens: ThemeConfig['token'] = {
  colorBgContainer: '#fff',
};

const darkTokens: ThemeConfig['token'] = {
  colorBgContainer: '#0f0f0f',
};

/** Ajustes por componente de antd (p. ej. `Button: { borderRadius: 4 }`). */
const components: ThemeConfig['components'] = {};

export function getAntdTheme(isDark: boolean): ThemeConfig {
  return {
    token: { ...brandTokens, ...(isDark ? darkTokens : lightTokens) },
    components,
    algorithm: isDark ? theme.darkAlgorithm : theme.defaultAlgorithm,
  };
}
